<template>
    <v-container id="placement-preference" fluid>
        <v-card-subtitle class="px-0">
            <v-icon :color="kingsGold" left>mdi-account-multiple</v-icon>Cluster Placement
            <br>
            Residents can be placed in a unit with students who share similar interest (see Interest
            Groups below in First Choice, Second Choice and Third Choice).
        </v-card-subtitle>
        <v-row>
            <v-col cols="12">
                <v-select v-model="item.clusterPlacement" dense hide-details :items="clusterPlacementItems"
                    label="Cluster Placement" outlined placeholder="Please select..." required
                    :rules="clusterPlacementRules">
                </v-select>
            </v-col>
        </v-row>
        <v-card-subtitle v-if="item.clusterPlacement == 'Interested'" class="px-0">
            <v-icon :color="kingsGold" left>mdi-format-list-numbered</v-icon>Cluster Placement
            Preference
            <br>
            If you are interested in such a placement, please indicate your first, second and third
            choices for placement clusters.
        </v-card-subtitle>
        <v-row v-if="item.clusterPlacement == 'Interested'">
            <v-col cols="12" md="4">
                <v-select v-model="item.clusterChoice01" dense :items="clusterChoice01Items" label="First Choice"
                    outlined placeholder="Please select..." required :rules="clusterChoice01Rules">
                </v-select>
            </v-col>
            <v-col cols="12" md="4">
                <v-select v-model="item.clusterChoice02" dense :items="clusterChoice02Items" label="Second Choice"
                    outlined placeholder="Please select..." required :rules="clusterChoice02Rules">
                </v-select>
            </v-col>
            <v-col cols="12" md="4">
                <v-select v-model="item.clusterChoice03" dense :items="clusterChoice03Items" label="Third Choice"
                    outlined placeholder="Please select..." required :rules="clusterChoice03Rules">
                </v-select>
            </v-col>
        </v-row>
        <v-card-subtitle v-if="item.clusterPlacement == 'Interested'" class="px-0">
            <v-icon :color="kingsGold" left>mdi-format-list-numbered</v-icon>Building Preference OR
            Cluster Placement
            <br>
            If we find that we can accommodate only your building preference OR your cluster placement,
            which is most important to you?
        </v-card-subtitle>
        <v-row v-if="item.clusterPlacement == 'Interested'">
            <v-col cols="12">
                <v-select v-model="item.clusterBuildingPreference" dense :items="clusterBuildingPreferenceItems"
                    label="Most Important" outlined placeholder="Please select..." required
                    :rules="clusterBuildingPreferenceRules">
                </v-select>
            </v-col>
        </v-row>
        <v-card-subtitle class="px-0">
            <v-icon :color="kingsGold" left>mdi-head-heart</v-icon>Lifestyle (Please check all that
            apply)
        </v-card-subtitle>
        <v-row>
            <v-col cols="12">
                <v-checkbox v-model="item.lifestyle" dense hide-details
                    label="I expect to get up before 9AM on weekdays" multiple
                    value="I expect to get up before 9AM on weekdays">
                </v-checkbox>
                <v-checkbox v-model="item.lifestyle" dense hide-details label="I usually stay up past midnight" multiple
                    value="I usually stay up past midnight">
                </v-checkbox>
                <v-checkbox v-model="item.lifestyle" dense hide-details
                    label="Any kind of noise distracts me while im studying" multiple
                    value="Any kind of noise distracts me while im studying">
                </v-checkbox>
                <v-checkbox v-model="item.lifestyle" dense hide-details label="I like to study with background noise"
                    value="I like to study with background noise">
                </v-checkbox>
                <v-checkbox v-model="item.lifestyle" dense hide-details
                    label="I want my room to be a gathering place for friends" multiple
                    value="I want my room to be a gathering place for friends">
                </v-checkbox>
                <v-checkbox v-model="item.lifestyle" dense hide-details
                    label="I prefer not to have many visitors in my room" multiple
                    value="I prefer not to have many visitors in my room">
                </v-checkbox>
                <v-checkbox v-model="item.lifestyle" dense hide-details label="I plan to maintain a fitness program"
                    multiple value="I plan to maintain a fitness program">
                </v-checkbox>
                <v-checkbox v-model="item.lifestyle" dense hide-details
                    label="I plan to tryout for a visitor sports team" multiple
                    value="I plan to tryout for a visitor sports team">
                </v-checkbox>
                <v-checkbox v-model="item.lifestyle" dense hide-details
                    label="I have toured/visited the residences at King's Unversity College" multiple
                    value="I have toured/visited the residences at King's Unversity College">
                </v-checkbox>
                <v-checkbox v-model="item.lifestyle" dense hide-details
                    label="I would like to be involved in the Residence Council or King's University College Student Council"
                    multiple
                    value="I would like to be involved in the Residence Council or King's University College Student Council">
                </v-checkbox>
                <v-checkbox v-model="item.lifestyle" dense hide-details
                    label="I am a smoker (Please be advised that smoking is NOT permitted in any residence building)"
                    multiple value="I am a smoker">
                </v-checkbox>
            </v-col>
        </v-row>
        <v-card-subtitle class="px-0">
            <v-icon :color="kingsGold" left>mdi-bed</v-icon>My room is
        </v-card-subtitle>
        <v-row>
            <v-col cols="12">
                <v-radio-group v-model="item.lifestyleMyRoomIs" required :rules="lifestyleMyRoomIsRules">
                    <v-radio v-for="(item, index) in lifestyleMyRoomIsItems" :key="index" :label="item.text"
                        :value="item.value"></v-radio>
                </v-radio-group>
            </v-col>
            <v-col cols="12">
                <v-textarea v-model="item.applicantInterests" auto-grow counter="512" dense
                    label="My Personal Interests" outlined placeholder="Please provide any hobbies or interests"
                    :rules="applicantInterestsRules">
                </v-textarea>
            </v-col>
        </v-row>
        <v-card-subtitle class="px-0">
            <v-icon :color="kingsGold" left>mdi-human-greeting</v-icon>Tour Room
            <br>
            Residents have the opportunity to apply to be a tour room for prospective students and be
            paid an honorarium for this role. As a tour room, your role will be to show your room to
            students who are touring King's residence as they consider applying' to King's, and act as a
            King's ambassador. If you are interested in this role, please indicate this by selecting
            <b>YES</b> below.
        </v-card-subtitle>
        <v-row>
            <v-col cols="12">
                <v-radio-group v-model="item.tourRoom" required :rules="tourRoomRules">
                    <v-radio v-for="(item, index) in tourRoomItems" :key="index" :label="item.text" :value="item.value">
                    </v-radio>
                </v-radio-group>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'applicant-placement-preference',
    props: {
        item: {
            required: true,
            type: Object
        },
        formSettings: {
            required: true
        },
        residenceTermsAppliedTo: {
            required: true
        }
    },
    data() {
        return {
            applicantInterestsRules: [
                v => !!v || 'Personal interests is required',
                v => (v && v.length <= 512) || 'Personal interests must be between 1 and 512 characters',
            ],
            clusterBuildingPreferenceItems: [{
                    text: 'Being placed in my first building preference',
                    value: 'Building'
                },
                {
                    text: 'Being placed in the cluster group of my choice (1st or 2nd choice)',
                    value: 'Cluster'
                }
            ],
            clusterBuildingPreferenceRules: [
                v => !!v || 'Building or cluster preference is required'
            ],
            clusterChoiceItems: [{
                    text: 'Academic Success',
                    value: 'Academic Success'
                },
                {
                    text: 'Arts (theatre, music, writing. etc.)',
                    value: 'Arts'
                },
                {
                    text: 'Business and BMOS',
                    value: 'Business and BMOS'
                },
                {
                    text: 'Catholic Youth',
                    value: 'Catholic Youth'
                },
                {
                    text: 'Childhood and Social Institutions Program',
                    value: 'Childhood and Social Institutions Program'
                },
                {
                    text: 'Healthy Lifestyles',
                    value: 'Healthy Lifestyles'
                },
                {
                    text: 'International Experience',
                    value: 'International Experience'
                },
                {
                    text: 'Leadership',
                    value: 'Leadership'
                },
                {
                    text: 'Social Justice and Peace',
                    value: 'Social Justice and Peace'
                }
            ],
            clusterChoice01Rules: [
                v => !!v || 'First choice is required'
            ],
            clusterChoice02Rules: [
                v => !!v || 'Second choice is required'
            ],
            clusterChoice03Rules: [
                v => !!v || 'Third choice is required'
            ],
            clusterPlacementItems: [{
                    text: 'I am interested in a cluster placement',
                    value: 'Interested'
                },
                {
                    text: 'I am NOT interested in a cluster placement',
                    value: 'Not interested'
                }
            ],
            clusterPlacementRules: [
                v => !!v || 'Cluster placement is required'
            ],
            lifestyleMyRoomIsItems: [{
                    text: 'Very neat',
                    value: '1'
                },
                {
                    text: '2',
                    value: '2'
                },
                {
                    text: '3',
                    value: '3'
                },
                {
                    text: '4',
                    value: '4'
                },
                {
                    text: '5',
                    value: '5'
                },
                {
                    text: '6',
                    value: '6'
                },
                {
                    text: '7',
                    value: '7'
                },
                {
                    text: '8',
                    value: '8'
                },
                {
                    text: '9',
                    value: '9'
                },
                {
                    text: 'Very messy',
                    value: '10'
                }
            ],
            lifestyleMyRoomIsRules: [
                v => !!v || 'Room neatness is required'
            ],
            photoUpload: '',
            photoUploadDialog: false,
            photoUploadRules: [
                v => !!v || 'A valid photo must be uploaded'
            ],
            photoUploadSelect: '',
            photoUploadSelectRules: [
                v => (!v && v.size > 0) || v.size < 5000000 || 'Please select a valid photo within the specified requirements'
            ],
            tourRoomItems: [{
                    text: 'YES, I am interested in this role',
                    value: 'Yes'
                },
                {
                    text: 'NO, I am not interested in this role',
                    value: 'No'
                }
            ],
            tourRoomRules: [
                v => !!v || 'Tour room is required'
            ],
            valid: true
        }
    },
    computed: {
        clusterChoice01Items() {
            return this.clusterChoiceItems;
        },
        clusterChoice02Items() {
            let secondChoiceItems = [];

            for (let i = 0; i < this.clusterChoiceItems.length; i++) {
                if (!(this.clusterChoiceItems[i].value == this.item.clusterChoice01)) {
                    secondChoiceItems.push(this.clusterChoiceItems[i]);
                }
            }

            return secondChoiceItems;
        },
        clusterChoice03Items() {
            let thirdChoiceItems = [];

            for (let i = 0; i < this.clusterChoiceItems.length; i++) {
                if (!(this.clusterChoiceItems[i].value == this.item.clusterChoice01) && !(this.clusterChoiceItems[i].value == this.item.clusterChoice02)) {
                    thirdChoiceItems.push(this.clusterChoiceItems[i]);
                }
            }

            return thirdChoiceItems;
        },
        kingsGold() {
            return '#d7ae28';
        },
        successColor() {
            return '#1bc5bd';
        }
    }
}
</script>

<style scoped>
.col-12 {
    padding-bottom: 0;
    padding-top: 0;
}

.v-input--checkbox,
.v-input--radio-group {
    margin-top: 0;
}
</style>